import { SimplePieChart } from 'components/SimplePieChart/SimplePieChart';
import { SeriesPieOptions, Options } from 'highcharts';
import { useEffect, useState } from 'react';
import {
    connectedColor,
    disconnectedColor,
} from 'store/services/device-status';
import { ConnectivitySummary } from 'types';

export interface ConnectivityPieChartProps {
    connectivitySummary: ConnectivitySummary;
}

export const ConnectivityPieChart = ({
    connectivitySummary,
}: ConnectivityPieChartProps) => {
    const [series, setSeries] = useState<SeriesPieOptions[]>([]);

    const options: Options = {
        title: { text: 'Current Connectivity' },
        chart: {
            height: 300,
            width: 300,
        },
        tooltip: {
            formatter: function () {
                return (
                    this.point.name + ': ' + this.percentage.toFixed(2) + '%'
                );
            },
        },
        plotOptions: {
            pie: {
                // events: {
                //     click: function (event) {
                //          TODO: modal that shows a list with CSV export of the devices in each pie segment. https://tankutility.atlassian.net/browse/SW-3953
                //     },
                // },
                cursor: 'pointer',
            },
        },
    };

    useEffect(() => {
        if (connectivitySummary) {
            const updatedSeries: SeriesPieOptions[] = [
                {
                    name: 'Connectivity',
                    type: 'pie',
                    data: [
                        {
                            name: 'Connected',
                            y: connectivitySummary.connectedCount,
                            color: connectedColor,
                        },
                        {
                            name: 'Disconnected',
                            y: connectivitySummary.disconnectedCount,
                            color: disconnectedColor,
                        },
                    ],
                },
            ];
            setSeries(updatedSeries);
        }
    }, [connectivitySummary]);

    return (
        <div data-testid="ConnectivityPieChart">
            <SimplePieChart options={options} series={series} />
        </div>
    );
};
